import React, { useState, useEffect } from 'react';
import { store } from '../index';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../helpers/isAuthenticated';

export default ComposedComponent => {
  function AuthenticatedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    
    const getLoginState = () => {
      return {
        userLoggedIn: !!store.getState().login._jwt,
        user: store.getState().login._user,
        jwt: store.getState().login._jwt
      };
    };

    const [loginState, setLoginState] = useState(getLoginState());

    useEffect(() => {
      const updateLoginState = () => {
        setLoginState(getLoginState());
      };
      
      // You might want to subscribe to store changes here
      // store.subscribe(updateLoginState);
      
      return () => {
        // Cleanup subscription if needed
      };
    }, []);
    
    if (isAuthenticated()) {
      return (
        <ComposedComponent
          {...props}
          user={loginState.user}
          jwt={loginState.jwt}
          userLoggedIn={loginState.userLoggedIn} />
      );
    } else {
      if (location.pathname !== '/login') {
        console.log(location.pathname);
        navigate("/login");
      }
    }
    return <React.Fragment></React.Fragment>;
  }
  
  return AuthenticatedComponent;
};
